(function () {
  'use strict';

  const POPUP_COMPONENT = 'popup-component';
  const POPUP_CLOSE = '[data-popup-close]';
  const NOTIFICATION_FORM = '[data-notification-form]';
  const HEADING = '[data-product-notification-heading]';
  const SUCCESS_CLASS = 'has-success';
  const HIDDEN_CLASS = 'hidden';
  const KLAVIYO_KEY = 'Xtq7be';

  if (customElements.get('product-notification')) return;

  customElements.define('product-notification', class extends HTMLElement {
    constructor() {
      super();
      this.notificationForm = this.querySelector(NOTIFICATION_FORM);
      this.popup = this.closest('dialog');
      this.popupClose = this.popup.querySelector(POPUP_CLOSE);
      this._unsubscribeVariant = null;
    }

    connectedCallback() {
      this.notificationForm.addEventListener('submit', (e) => this.onSubmit(e));
      this.popupClose.addEventListener('click', () => this.removeStorage());

      // Keep data-variant-id in sync whenever the customer changes variant selection
      this.syncVariantId();
      if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.optionValueSelectionChange) {
        this._unsubscribeVariant = window.subscribe(
          window.theme.PUB_SUB_EVENTS.optionValueSelectionChange,
          () => this.syncVariantId()
        );
      }
    }

    disconnectedCallback() {
      if (this._unsubscribeVariant) this._unsubscribeVariant();
    }

    // Pull the current variant ID from the product form's hidden [name=id] input
    syncVariantId() {
      const productForm = this.closest('product-form');
      if (!productForm) return;
      const variantInput = productForm.querySelector('form [name=id]');
      if (variantInput && variantInput.value) {
        this.notificationForm.dataset.variantId = variantInput.value;
      }
    }

    onSubmit(e) {
      e.preventDefault();

      const email = this.notificationForm.querySelector('input[type="email"]').value.trim();
      // Prefer URL ?variant= param — Shopify always keeps this current via pushState
      const urlVariantId = new URLSearchParams(window.location.search).get('variant');
      const variantId = urlVariantId || this.notificationForm.dataset.variantId;

      if (!email || !variantId) return;

      const submitBtn = this.notificationForm.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_KEY}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      })
      .then((res) => {
        // Klaviyo returns 202 Accepted on success
        if (res.ok || res.status === 202) {
          this.showSuccess();
        } else {
          throw new Error(`Klaviyo API error: ${res.status}`);
        }
      })
      .catch((err) => {
        console.error('[MGC] Klaviyo back-in-stock subscribe failed:', err);
        if (submitBtn) submitBtn.disabled = false;
        // Fall back to native Shopify contact form so merchant still gets an email
        this.writeStorage();
        this.notificationForm.submit();
      });
    }

    showSuccess() {
      this.querySelector(HEADING).classList.add(HIDDEN_CLASS);
      this.closest(POPUP_COMPONENT).classList.add(SUCCESS_CLASS);
      this.popup.removeAttribute('inert');
      if (typeof this.popup.showModal === 'function') {
        this.popup.showModal();
      } else {
        this.popup.setAttribute('open', '');
      }
      this.removeStorage();
    }

    writeStorage() {
      if (typeof window.sessionStorage !== 'undefined') {
        window.sessionStorage.setItem('notification_form_id', this.notificationForm.id);
      }
    }

    removeStorage() {
      window.sessionStorage.removeItem('notification_form_id');
    }
  });
})();
